import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const SectionContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(1, 0)
}));

export const OfferLetterText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));
